export default "__VITE_ASSET__Dzuyk0Ap__"